import React, { useState } from 'react'
import { useTableFilterContext } from './Context'
import { FilterContainerBodyLayout } from './FilterContainer'
import type { TableFilterProps } from './types'
import { ListGroup } from 'react-bootstrap'
import map from 'lodash/map'
import includes from 'lodash/includes'
import filter from 'lodash/filter'
import keyBy from 'lodash/keyBy'
import mapValues from 'lodash/mapValues'

export const ListTableFilter = ({ field }: TableFilterProps) => {
  const { onFilter, getStoredFilter } = useTableFilterContext()
  const emptyValueLabel: string | undefined = field?.fieldSettings?.emptyValueLabel
  // An entry is a plain string, or `{ value, title }` when the stored value differs from its label.
  const listItems: (string | null)[] = [
    ...(emptyValueLabel ? [null] : []),
    ...map(field?.fieldSettings?.listValues ?? [], (entry) => entry?.value ?? entry),
  ]
  const titleByValue: Record<string, string> = mapValues(
    keyBy(
      filter(field?.fieldSettings?.listValues, (entry) => entry?.title !== undefined),
      'value'
    ),
    'title'
  )

  const initialValues = getStoredFilter()?.['$in'] ?? []
  const [selectedValues, setSelectedValues] = useState<(string | null)[]>(initialValues)

  const filterNow = () => {
    const extraFilter = { [field.name]: { $in: selectedValues } }
    onFilter(extraFilter)
  }

  const isAllSelected = selectedValues.length === listItems.length
  const onSelectAll = () => {
    if (isAllSelected) {
      setSelectedValues([])
    } else {
      setSelectedValues(listItems)
    }
  }

  return (
    <FilterContainerBodyLayout onOk={filterNow}>
      <ListGroup variant="flush">
        <ListGroup.Item onClick={onSelectAll} active={isAllSelected} action>
          {isAllSelected ? '(Unselect all)' : '(Select all)'}
        </ListGroup.Item>
        {map(listItems, (item) => {
          const isFound = includes(selectedValues, item)

          const handleSelect = () => {
            let theList = [...selectedValues]
            if (isFound) {
              //remove the item from the list
              theList = filter(theList, (e) => e !== item)
            } else {
              theList = [...theList, item]
            }
            //this will ensure that all unique string only
            const uniqueSet = Array.from(new Set(theList))
            setSelectedValues(uniqueSet)
          }

          return (
            <ListGroup.Item key={item ?? '__empty__'} action active={isFound} onClick={handleSelect}>
              {item === null ? emptyValueLabel : (titleByValue[item] ?? item)}
            </ListGroup.Item>
          )
        })}
      </ListGroup>
    </FilterContainerBodyLayout>
  )
}
